import React from 'react';
import { useTranslation } from 'react-i18next';
import RequestStats from '../components/statistics/RequestStats';
import UsageIndicator from '../components/statistics/UsageIndicator';

const Statistics = () => {
  const { t } = useTranslation('common');

  return (
    <div className="h-full bg-white p-6">
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">{t('statistics.title')}</h1>
      <div className="space-y-8">
        <UsageIndicator />
        <RequestStats />
      </div>
    </div>
  );
};

export default Statistics; 